import React, { useEffect, useState } from 'react';
import { Box, ButtonBase, InputBase, makeStyles } from '@material-ui/core';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import _ from 'lodash';
import { useDispatch } from 'react-redux';
import Text from '../../../components/Text';
import { equipmentAPI } from '../../../apis';
import { CloseIcon, DropRightIcon, EditIcon } from '../../../components/Icon';
import { ReactComponent as EquipmentPinIcon } from '../../../static/images/EquipmentPinIcon.svg';
import { ReactComponent as EquipmentUnPinIcon } from '../../../static/images/EquipmentUnPinIcon.svg';
import { ReactComponent as EditColorIcon } from '../../../static/images/EditColorIcon.svg';
import { closeFullScreen, openFullScreen } from '../../../redux/actions';
import { ReactComponent as SwitchOn } from '../../../static/images/SwitchOn.svg';
import { ReactComponent as SwitchOff } from '../../../static/images/SwitchOff.svg';
import { ReactComponent as TvFilterIcon } from '../../../static/images/TvFilterIcon.svg';
import Card from './Card';
import ViewOther from './ViewOther';
import EditColorPopup from './EditColorPopup';
import AvailableFilterPopup from './AvailableFilterPopup';

const useStyles = makeStyles(() => ({
  root: {
    width: '100vw',
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: '2.62rem',
    width: '100%',
    backgroundColor: '#FFFFFF',
    boxShadow: '0px 1px 0px 0px #E4E7EB',
  },
  body: {
    padding: '1.5rem 1.25rem 0 2.5rem',
    display: 'flex',
    flex: 1,
    gridGap: '1.25rem',
  },
  CloseIcon: {
    fontSize: '1rem',
    color: '#FFFFFF',
  },
  dropRightIcon: {
    fontSize: '0.625rem',
    color: '#2E4469',
  },
  showBusStop: {
    fontSize: '0.875rem',
    color: '#7D86A9',
    gap: '0.3rem',
    fontFamily: 'NotoSans-Medium',
    marginRight: '0.5rem',
  },
  switch: {
    width: '2.75rem',
    height: '1.47rem',
  },
  edit: {
    fontSize: '1rem',
    marginLeft: '0.5rem',
    color: '#2E4469',
  },
  remarkInput: {
    '&.MuiInputBase-multiline': {
      color: '#2E4469',
      fontSize: '1rem',
      height: '100%',
      border: 'solid 1px #E4E7EB',
      padding: 'unset',
    },
    '& .MuiInputBase-inputMultiline': {
      height: '100% !important',
      overflow: 'auto !important',
      lineHeight: 'normal',
    },
  },
}));

const rowItemCount = 5; // 单行显示的item个数

function transformWardData(data) {
  // 1. 处理病房数据，添加 title 并转换 id
  const wardData = data.map((ward) => ({
    id: ward.wardId, // wardId → id
    wardId: ward.wardId,
    wardName: ward.wardName,
    title: ward.wardName,
    checked: true,
    satelliteStores: ward.satelliteStores,
    name: ward.wardName,
  }));

  // 2. 处理卫星商店数据，添加 title 并转换 id
  const satelliteStoresData = data.flatMap((ward) =>
    ward.satelliteStores.map((store) => ({
      wardId: ward.wardId,
      id: store.satelliteStoreId, // satelliteStoreId → id
      satelliteStoreId: store.satelliteStoreId,
      satelliteStoreName: store.satelliteStoreName,
      title: `    ${store.satelliteStoreName}`,
      name: store.satelliteStoreName,
      checked: true,
    }))
  );

  const newWardData = wardData.map((ward) => {
    console.warn('ward', satelliteStoresData);
    const satelliteStores = satelliteStoresData.filter((store) => store.wardId === ward.id);
    ward.satelliteStores = satelliteStores;
    return ward;
  });

  // wardData.satelliteStores=satelliteStoresData;
  // 3. 合并结果
  // return [...wardData, ...satelliteStoresData];
  return [...newWardData];
}

const TvDashboard = () => {
  const classes = useStyles();
  const history = useHistory();
  const [viewOther, setViewOther] = useState(false);
  const [editColor, setEditColor] = useState(false);
  const [dashboardData, setDashboardData] = useState({
    categoryQtys: [],
    inUsedQty: '',
    qty: '',
    wards: [],
    dashName: '',
  });
  const [remark, setRemark] = useState('');
  const [satelliteList, setSatelliteList] = useState([]);
  const dispatch = useDispatch();
  const [type, setType] = useState('NONE');
  const satelliteData = _.keyBy(satelliteList, 'name');
  const [editRemark, setEditRemark] = useState(false);
  const [availableFilterPopup, setAvailableFilterPopup] = useState(false);
  const [availableFilterList, setAvailableFilterList] = useState([]);
  const [needUpdateFilterList, setNeedUpdateFilterList] = useState(true);
  console.log('satelliteData', satelliteData);

  const getTvDashboardList = async (category, availableFilter) => {
    try {
      let categoryNames = _.filter(dashboardData.categoryQtys, (item) => item.checked).map((item) => item.name);
      // 如果全部反选，则传null
      categoryNames = categoryNames.length === 0 ? null : categoryNames;
      let wardNames = [];
      _.forEach(availableFilter, (item) => {
        if (item.checked) {
          wardNames.push(item.name);
        }
        _.forEach(item.satelliteStores, (store) => {
          if (store.checked) {
            wardNames.push(store.name);
          }
        });
      });
      if (wardNames?.length === 0 && availableFilter) {
        wardNames = null;
      }

      const params = {
        categoryNames: category ?? categoryNames,
        type,
        wardNames,
      };
      const { result } = await equipmentAPI.getTvDashboardList(params);
      setDashboardData({
        ...result.inUseds,
        dashName: result.dashName,
      });
      setSatelliteList(result.nonUseds);
      const availableList = _.find(result.nonUseds, (item) => item.name === 'Available');
      const statWards = transformWardData(availableList?.statWards);
      console.log('statWards', statWards);

      if (needUpdateFilterList) {
        setAvailableFilterList(statWards);
        setNeedUpdateFilterList(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getDashboardRemark = async () => {
    try {
      const { result } = await equipmentAPI.getDashboardRemark();
      setRemark(result);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getTvDashboardList([]);
    getDashboardRemark();
  }, [type]);

  const handleFilterCategory = (name) => async () => {
    try {
      const categoryNames = _.filter(dashboardData.categoryQtys, (item) =>
        item.name === name ? !item.checked : item.checked
      ).map((item) => item.name);
      getTvDashboardList(categoryNames?.length === 0 ? null : categoryNames, availableFilterList);
    } catch (error) {
      console.log(error);
    }
  };

  const handlePin = (tgtWardId) => async () => {
    try {
      const params = {
        tgtWardId,
      };
      await equipmentAPI.pingDashboard(params);
      getTvDashboardList(null, availableFilterList);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    dispatch(openFullScreen());
    if (window.innerWidth < 1660) {
      document.documentElement.style.fontSize = '10px';
    } else if (window.innerWidth < 1920) {
      document.documentElement.style.fontSize = '12px';
    } else {
      document.documentElement.style.fontSize = '14px';
    }

    return () => {
      dispatch(closeFullScreen());
      document.documentElement.style.fontSize = '';
    };
  }, []);

  // 保存Remark
  const handleSaveRemark = async () => {
    try {
      await equipmentAPI.updateDashboardRemark({ remark });
      setEditRemark(false);
    } catch (error) {
      console.log(error);
    }
  };

  // 过滤available
  const handleUpdateAvailableFilter = async (list) => {
    try {
      setAvailableFilterList(list);
      getTvDashboardList(null, list);
      setAvailableFilterPopup(false);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Box className={classes.root}>
      {viewOther && <ViewOther allData={satelliteData} handleClose={() => setViewOther(false)} />}
      {editColor && (
        <EditColorPopup handleSearch={() => getTvDashboardList()} handleClose={() => setEditColor(false)} />
      )}
      {availableFilterPopup && (
        <AvailableFilterPopup
          handleClose={() => setAvailableFilterPopup(false)}
          handleUpdate={handleUpdateAvailableFilter}
          availableFilterList={availableFilterList}
        />
      )}
      <Box className={classes.header}>
        <Text fontSize="0.875rem" color="#538FFF" fontWeight="700" ml="2.62rem">
          Ward Equipment Dashboard : {dashboardData?.dashName}
        </Text>
        <Box display="flex">
          <ButtonBase
            className={classes.showBusStop}
            onClick={() => {
              setType((prevType) => (prevType === 'ALL' ? 'NONE' : 'ALL'));
              setNeedUpdateFilterList(true);
            }}
          >
            Current Ward Equipment Only
            {type === 'NONE' ? <SwitchOn className={classes.switch} /> : <SwitchOff className={classes.switch} />}
          </ButtonBase>
          <ButtonBase onClick={() => setEditColor(true)}>
            <Box display="flex" alignItems="center" gridGap="0.5rem" p="0 1.25rem" bgcolor="#F1F6FF" height="100%">
              <EditColorIcon />
              <Text fontSize="1rem" color="#538fff">
                Edit Color
              </Text>
            </Box>
          </ButtonBase>
          <ButtonBase onClick={() => history.push('/equipment')}>
            <Box
              width="2.62rem"
              height="2.62rem"
              display="flex"
              alignItems="center"
              justifyContent="center"
              bgcolor="#538FFF"
            >
              <CloseIcon className={classes.CloseIcon} />
            </Box>
          </ButtonBase>
        </Box>
      </Box>
      <Box className={classes.body}>
        <Box display="flex" flexDirection="column" width="75vw">
          <Box display="flex" alignItems="center" flexWrap="wrap" gridGap="1.25rem">
            <Text fontSize="1.5rem" fontWeight="700" color="#2E4469">
              On loan (QTY : {dashboardData?.inUsedQty})
            </Text>
            {dashboardData?.categoryQtys?.map((item) => (
              <Card
                type="category"
                name={`${item.name} : ${item.inUsedQty}`}
                color={item.color}
                checked={item.checked}
                onClick={handleFilterCategory(item.name)}
                key={item.name}
              />
            ))}
          </Box>
          <Box display="flex" flexDirection="column" mt="1rem" flex={1}>
            <Box
              display="flex"
              alignItems="center"
              borderRadius="1rem 1rem 0rem 0rem"
              bgcolor="#538fff"
              height="2.625rem"
              pl="1.25rem"
              pr="1.25rem"
              gridGap="2.5rem"
            >
              <Text fontSize="1.125rem" color="#FFFFFF" fontWeight="700" style={{ flexBasis: '50%' }}>
                WARD
              </Text>
              <Text fontSize="1.125rem" color="#FFFFFF" fontWeight="700" style={{ flexBasis: '50%' }}>
                WARD
              </Text>
            </Box>
            <Box
              display="grid"
              gridTemplateColumns="auto 1fr auto 1fr"
              gridTemplateRows="repeat(auto-fill, 3.75rem)"
              flex={1}
              bgcolor="#ffffff"
              pl="1.25rem"
              pr="1.25rem"
            >
              {dashboardData?.wards?.map((item) => (
                <React.Fragment key={item.wardId}>
                  <Box
                    display="flex"
                    alignItems="flex-start"
                    gridGap="0.5rem"
                    borderBottom="1px solid #EEEEEE"
                    style={{ gridRowStart: `span ${Math.ceil(item?.assets?.length / rowItemCount) ?? 1}` }}
                  >
                    <Box
                      display="flex"
                      alignItems="center"
                      gridGap="0.5rem"
                      pr="1rem"
                      borderBottom="1px solid #EEEEEE"
                      height="3.75rem"
                      flex={1}
                    >
                      <ButtonBase onClick={handlePin(item.wardId)}>
                        {item?.isTop ? <EquipmentPinIcon /> : <EquipmentUnPinIcon />}
                      </ButtonBase>
                      <Text fontSize="1.375rem" fontWeight="700" color="#2E4469">
                        {item.wardName}
                      </Text>
                    </Box>
                  </Box>
                  <Box
                    borderBottom="1px solid #EEEEEE"
                    style={{ gridRowStart: `span ${Math.ceil(item?.assets?.length / rowItemCount)}` }}
                  >
                    {_.chunk(item?.assets, rowItemCount).map((rowItem, rowIndex) => (
                      <Box
                        height="3.75rem"
                        display="flex"
                        alignItems="center"
                        borderBottom="1px solid #EEEEEE"
                        gridGap="0.25rem"
                        key={rowIndex}
                      >
                        {rowItem.map((assetItem) => (
                          <Card
                            name={assetItem.refNo ?? '--'}
                            color={assetItem.color}
                            key={assetItem.assetId}
                            status={assetItem.status ?? '-'}
                            model={assetItem.model ?? '-'}
                          />
                        ))}
                      </Box>
                    ))}
                  </Box>
                </React.Fragment>
              ))}
            </Box>
          </Box>
          <Box />
        </Box>
        <Box width="22vw">
          <Box display="flex" flexDirection="column" height="100%" gridGap="1rem">
            <Box
              display="flex"
              flexDirection="column"
              gridGap="0.38rem"
              bgcolor="#FFFFCC"
              borderRadius="1rem"
              p="1.25rem 1rem"
              height="14rem"
            >
              <Text fontSize="1.125rem" color="#231F20" fontWeight="700">
                Remarks
                <ButtonBase onClick={() => setEditRemark((prev) => !prev)}>
                  <span>
                    <EditIcon className={classes.edit} />
                  </span>
                </ButtonBase>
              </Text>
              {editRemark ? (
                <InputBase
                  className={classes.remarkInput}
                  value={remark}
                  onChange={(event) => setRemark(event.target.value)}
                  onBlur={handleSaveRemark}
                  multiline
                />
              ) : (
                <Text fontSize="1rem" color="#2E4469" whiteSpace="pre-wrap" style={{ overflow: 'auto' }}>
                  {remark}
                </Text>
              )}
            </Box>
            <Text fontSize="1.5rem" fontWeight="700" color="#2e4469">
              Available (QTY : {satelliteData?.Available?.qty})
            </Text>
            <Box display="flex" flexDirection="column" bgcolor="#FFF" borderRadius="1rem" flex={1}>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="flex-end"
                borderRadius="1rem 1rem 0rem 0rem"
                bgcolor="#E4E7EB"
                height="2.625rem"
                pl="1.25rem"
                pr="1.25rem"
                gridGap="2.5rem"
              >
                <ButtonBase onClick={() => setAvailableFilterPopup(true)}>
                  <TvFilterIcon />
                </ButtonBase>
              </Box>
              <Box display="flex" flexDirection="column" p="0 1.25rem">
                {satelliteData?.Available?.wards?.map((item) => (
                  <Box display="flex" alignItems="center" borderBottom="1px solid #EEEEEE" p="0.63rem 0" key={item?.id}>
                    <Box display="flex" alignItems="center" gridGap="0.5rem" mr="1rem">
                      <Text fontSize="1.375rem" fontWeight="700" color="#2E4469">
                        {item?.name ?? '--'}
                      </Text>
                    </Box>
                    <Box display="flex" alignItems="center" gridGap="0.5rem 0.25rem" flexWrap="wrap">
                      {item?.assets?.map?.((assetItem) => (
                        <Card
                          name={assetItem.refNo ?? '--'}
                          color={assetItem.color}
                          key={assetItem.assetId}
                          status={assetItem.status ?? '-'}
                          model={assetItem.model ?? '-'}
                        />
                      ))}
                    </Box>
                  </Box>
                ))}
              </Box>
            </Box>
            <ButtonBase onClick={() => setViewOther(true)}>
              <Box
                display="flex"
                flexDirection="column"
                borderRadius="1.5rem 1.5rem 0rem 0rem"
                bgcolor="#E4E7EB"
                p="0.62rem 1.2rem"
                gridGap="0.5rem"
                width="100%"
              >
                <Box display="flex" alignItems="center" justifyContent="space-between">
                  <Box display="flex" gridGap="1.62rem">
                    <Text fontSize="1rem" fontWeight="700" color="#2E4469">
                      Reprocessing ({satelliteData?.Reprocessing?.qty})
                    </Text>
                    <Text fontSize="1rem" fontWeight="700" color="#2E4469">
                      Not for loan ({satelliteData?.['Not for loan']?.qty})
                    </Text>
                  </Box>

                  <DropRightIcon className={classes.dropRightIcon} />
                </Box>

                <Box display="flex" gridGap="1.62rem">
                  <Text fontSize="1rem" fontWeight="700" color="#2E4469">
                    Reserved ({satelliteData?.Reserved?.qty})
                  </Text>
                  <Text fontSize="1rem" fontWeight="700" color="#2E4469">
                    Condemned ({satelliteData?.Condemned?.qty})
                  </Text>
                  <Text fontSize="1rem" fontWeight="700" color="#2E4469">
                    Repairing ({satelliteData?.Repairing?.qty})
                  </Text>
                </Box>
              </Box>
            </ButtonBase>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default TvDashboard;
